import { useEffect, useRef } from "react";

export default function useAutoRefresh(fn, ms = 15000) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    const tick = () => { if (document.visibilityState === "visible") ref.current?.(); };
    const iv = setInterval(tick, ms);
    const onVis = () => { if (document.visibilityState === "visible") ref.current?.(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", onVis); };
  }, [ms]);
}
